import { createSlice } from '@reduxjs/toolkit';

const cartTableSlice = createSlice({
  name: 'cartTableSlice',
  initialState: {
    isAlertErrorVoucher: false,
    isVirtualVoucher: false,
  },
  reducers: {
    setAlertErrorVoucher: (state, action) => {
      state.isAlertErrorVoucher = action.payload;
    },
    setVirtualVoucher: (state, action) => {
      state.isVirtualVoucher = action.payload;
    },
  },
});

export const { setAlertErrorVoucher, setVirtualVoucher } =
  cartTableSlice.actions;
export default cartTableSlice.reducer;
